import React from "react";
import { Button, Modal } from "antd";
import { MdError } from "react-icons/md";
import "./ErrorModal.css";

function ErrorModal({ text, isErrorVisible, setIsErrorVisible, setNewState }) {
  return (
    <Modal
      visible={isErrorVisible}
      onOk={() => {
        setNewState();
        // setIsErrorVisible(false);
      }}
      onCancel={() => setIsErrorVisible(false)}
      footer={null}
      title="&nbsp;"
      width="auto"
      style={{ maxWidth: "400px", height: "300px" }}
      closable={false}
    >
      <div style={{ textAlign: "center", margin: 10 }}>
        <MdError size={30} />
        <div style={{ margin: "0px 26px 16px 26px" }}>{text}</div>
        <Button
          type="button"
          className="ahp-button"
          onClick={() => {
            setIsErrorVisible(false);
          }}
          style={{ marginBottom: 16 }}
        >
          OK
        </Button>
      </div>
    </Modal>
  );
}

export default ErrorModal;
